import {
  can,
} from "../../shared/auth/access";
import {
  TableState,
} from "../../shared/components/TableState";
import type {
  useSuppliersWorkspace,
} from "./useSuppliersWorkspace";

export function SupplierDocuments({ model }: { model: ReturnType<typeof useSuppliersWorkspace> ;}) {
  const { user, supplierTab, supplierAction, setSupplierAction, supplierActionPending, qualityScope, setQualityScope, qualityDocumentTypes, qualityDocumentFile, setQualityDocumentFile, qualityDocuments, documentSecurityLabels, documentVerificationLabels, loadQualityDocuments, uploadQualityDocument, verifyQualityDocument, createQualityDocumentType } = model;
  return (<>{supplierTab === "documents" ? (
    <>
      <div className="supplier-section-heading">
        <div>
          <h3>Kalite belgeleri</h3>
          <p>
            Yalnız güvenlik kontrolünden geçen güncel belgeler
            uygunlukta kullanılır.
          </p>
        </div>
        <button
          className="secondary-button"
          disabled={!can(user, "supplier.document.read")}
          onClick={loadQualityDocuments}
        >
          Belgeleri yenile
        </button>
      </div>
      <div className="inline-form-actions">
        {can(user, "supplier.document.verify") ? (
          <button
            className="primary-button"
            onClick={() => setSupplierAction("document")}
          >
            Belge yükle
          </button>
        ) : null}
        {can(user, "supplier.document.manage") ? (
          <button
            className="secondary-button"
            onClick={() => setSupplierAction("quality")}
          >
            Belge türü yapılandır
          </button>
        ) : null}
      </div>
      {supplierAction === "quality" ? (
        <div className="supplier-action-drawer">
          <h3>Zorunlu belge türü</h3>
          <label>
            Yeni belge türü kodu
            <input
              value={qualityScope.documentTypeCode}
              onChange={(event) =>
                setQualityScope((current) => ({
                  ...current,
                  documentTypeCode: event.target.value,
                }))
              }
            />
          </label>
          <label>
            Yeni belge türü adı
            <input
              value={qualityScope.documentTypeName}
              onChange={(event) =>
                setQualityScope((current) => ({
                  ...current,
                  documentTypeName: event.target.value,
                }))
              }
            />
          </label>
          <div className="inline-form-actions">
            <button
              className="secondary-button"
              onClick={() => setSupplierAction(null)}
            >
              Vazgeç
            </button>
            <button
              className="approve-button"
              disabled={supplierActionPending}
              onClick={createQualityDocumentType}
            >
              Zorunlu belge türünü yapılandır
            </button>
          </div>
        </div>
      ) : null}
      {supplierAction === "document" ? (
        <div className="supplier-action-drawer">
          <label>
            Belge türü
            <select
              value={qualityScope.documentTypeCode}
              onChange={(event) =>
                setQualityScope((current) => ({
                  ...current,
                  documentTypeCode: event.target.value,
                }))
              }
            >
              <option value="">Belge türü seçin</option>
              {qualityDocumentTypes
                .filter(
                  (item) =>
                    item.category === qualityScope.category,
                )
                .map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.name}
                  </option>
                ))}
            </select>
          </label>
          <label>
            Belge geçerlilik sonu
            <input
              type="date"
              value={qualityScope.validUntil}
              onChange={(event) =>
                setQualityScope((current) => ({
                  ...current,
                  validUntil: event.target.value,
                }))
              }
            />
          </label>
          <label>
            Kalite belgesi
            <input
              type="file"
              accept=".pdf,.docx,.xlsx,.png,.jpg,.jpeg"
              onChange={(event) =>
                setQualityDocumentFile(
                  event.target.files?.[0] ?? null,
                )
              }
            />
          </label>
          <div className="inline-form-actions">
            <button
              className="secondary-button"
              onClick={() => setSupplierAction(null)}
            >
              Vazgeç
            </button>
            <button
              className="approve-button"
              disabled={
                supplierActionPending || !qualityDocumentFile
              }
              onClick={uploadQualityDocument}
            >
              Belgeyi güvenli yükle
            </button>
          </div>
        </div>
      ) : null}
      {qualityDocuments.length ? (
        <div className="data-table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Belge</th>
                <th>Tür</th>
                <th>Sürüm</th>
                <th>Güvenlik</th>
                <th>Doğrulama</th>
                <th>Geçerlilik</th>
              </tr>
            </thead>
            <tbody>
              {qualityDocuments.map((item) => (
                <tr key={item.id}>
                  <td>
                    {item.original_name ?? item.originalName}
                  </td>
                  <td>
                    {item.document_type_code ??
                      item.documentTypeCode}
                  </td>
                  <td>{item.version}</td>
                  <td>
                    {documentSecurityLabels[
                      item.security_status ??
                      item.securityStatus ??
                      "PENDING"
                    ] ?? "Bilinmiyor"}
                  </td>
                  <td>
                    {(item.verification_status ??
                      item.verificationStatus) === "PENDING" &&
                      can(user, "supplier.document.verify") ? (
                      <button
                        className="secondary-button"
                        onClick={() =>
                          verifyQualityDocument(item.id)
                        }
                      >
                        Doğrula
                      </button>
                    ) : (
                      (documentVerificationLabels[
                        item.verification_status ??
                        item.verificationStatus ??
                        "PENDING"
                      ] ?? "Bilinmiyor")
                    )}
                  </td>
                  <td>
                    {item.valid_until ??
                      item.validUntil ??
                      "Süresiz"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <TableState
          title="Belge bulunmuyor"
          description={
            can(user, "supplier.document.verify")
              ? "İlk kalite belgesini yükleyin."
              : "Bu kapsam için kayıtlı belge yok."
          }
        />
      )}
    </>
  ) : null}</>);
}
